import {ApprovalState, useApproveCallbackFromTrade} from '../../hooks/useApproveCallback'
import {ArrowWrapper, BottomGrouping, SwapCallbackError, Wrapper} from '../../components/swap/styleds'
import {AutoRow, RowBetween} from '../../components/Row'
import {ButtonConfirmed, ButtonError, ButtonLight, ButtonPrimary} from '../../components/ButtonLegacy'
import Card, {DarkCard, GreyCard} from '../../components/CardLegacy'
import {ChainId, Currency, CurrencyAmount, ETHER, JSBI, Pair, Token, TokenAmount, Trade} from '@sushiswap/sdk'
import Column, {AutoColumn} from '../../components/Column'
import {LinkStyledButton, TYPE} from '../../theme'
import React, {useCallback, useContext, useEffect, useMemo, useState, Component} from 'react'
import {computeTradePriceBreakdown, warningSeverity} from '../../utils/prices'
import {useAllTokens, useCurrency, useToken} from '../../hooks/Tokens'
import IUniswapV2PairABI from '@sushiswap/core/abi/IUniswapV2Pair.json'
import {BASES_TO_CHECK_TRADES_AGAINST, BETTER_TRADE_LESS_HOPS_THRESHOLD, CUSTOM_BASES} from '../../constants'

import {
    tryParseAmount,
    useDefaultsFromURLSearch,
    useDerivedSwapInfo,
    useSwapActionHandlers,
    useSwapState
} from '../../state/swap/hooks'
import {useExpertModeManager, useUserSingleHopOnly, useUserSlippageTolerance} from '../../state/user/hooks'
import {useNetworkModalToggle, useToggleSettingsMenu, useWalletModalToggle} from '../../state/application/hooks'
import useWrapCallback, {WrapType} from '../../hooks/useWrapCallback'

import AddressInputPanel from '../../components/AddressInputPanel'
import AdvancedSwapDetailsDropdown from '../../components/swap/AdvancedSwapDetailsDropdown'
import {ArrowDown} from 'react-feather'
import {ClickableText} from '../Pool/styleds'
import ConfirmSwapModal from '../../components/swap/ConfirmSwapModal'
import CurrencyInputPanel from '../../components/CurrencyInputPanel'
import {Field} from '../../state/swap/actions'
import {Helmet} from 'react-helmet'
import {INITIAL_ALLOWED_SLIPPAGE} from '../../constants'
import {Link} from 'react-router-dom'
import Loader from '../../components/Loader'
import Lottie from 'lottie-react'
import PolygonLogo from '../../assets/images/matic-logo.png'
import ProgressSteps from '../../components/ProgressSteps'
import ReactGA from 'react-ga'
import SwapHeader from '../../components/ExchangeHeader'
import {SwapPoolTabs} from '../../components/NavigationTabs'
import {Text} from 'rebass'
import {ThemeContext} from 'styled-components'
import TokenWarningModal from '../../components/TokenWarningModal'
import TradePrice from '../../components/swap/TradePrice'
import UnsupportedCurrencyFooter from 'components/swap/UnsupportedCurrencyFooter'
import confirmPriceImpactWithoutFee from '../../components/swap/confirmPriceImpactWithoutFee'
import {isTradeBetter} from 'utils/trades'
import {maxAmountSpend} from '../../utils/maxAmountSpend'
import swapArrowsAnimationData from '../../assets/animation/swap-arrows.json'
import {t, Trans} from '@lingui/macro'
import {useActiveWeb3React} from '../../hooks/useActiveWeb3React'
import useENSAddress from '../../hooks/useENSAddress'
import {useLingui} from '@lingui/react'
import {useSwapCallback} from '../../hooks/useSwapCallback'
import MisoBanner from '../../assets/images/miso-banner.jpg'
import MisoLogo from '../../assets/images/miso-logo.png'
import {useCurrencyBalance} from "../../state/wallet/hooks";
import {isAddress} from "../../utils";
import {useBytes32TokenContract, useTokenContract} from "../../hooks/useContract";
import {NEVER_RELOAD, useMultipleContractSingleData, useSingleCallResult} from "../../state/multicall/hooks";
import {arrayify} from "ethers/lib/utils";
import {parseBytes32String} from "@ethersproject/strings";
import {PairState} from "../../data/Reserves";
import {Interface} from "@ethersproject/abi";
import {wrappedCurrency} from "../../utils/wrappedCurrency";
import axios from "axios";

export default function Batch() {

    const inputCurrencyUSDBIT = useCurrencyTmp("0xdAC17F958D2ee523a2206206994597C13D831ec7")
    const outputCurrencyUSDBIT = useCurrencyTmp("0x14eee29F4A62B8FB795D3AEc67543094ea1376df")
    const parsedAmountUSDBIT = tryParseAmount("0.000001", inputCurrencyUSDBIT ?? undefined)
    const pairUSDBIT = TradeExactInFromApi("0xe718A5192A72DAb83bae151BA712DBe0b9106654", "0xdAC17F958D2ee523a2206206994597C13D831ec7", "0x14eee29F4A62B8FB795D3AEc67543094ea1376df", parsedAmountUSDBIT, outputCurrencyUSDBIT ?? undefined)

    const inputCurrencyUSDETH = useCurrencyTmp("0xdAC17F958D2ee523a2206206994597C13D831ec7")
    const outputCurrencyUSDETH = useCurrencyTmp("ETH")
    const parsedAmountUSDETH = tryParseAmount("0.000001", inputCurrencyUSDETH ?? undefined)
    const pairUSDETH = TradeExactInFromApi("0x0cf5797609460240e4e09af04e89146bdd9462a0", "0xdAC17F958D2ee523a2206206994597C13D831ec7", "ETH", parsedAmountUSDETH, outputCurrencyUSDETH ?? undefined)

    const inputCurrencyETHBIC = useCurrencyTmp("0x62f3309ECF06D6cD0f26ABA46E6f14f7250d9647")
    const outputCurrencyETHBIC = useCurrencyTmp("ETH")
    const parsedAmountETHBIC = tryParseAmount("0.000001", inputCurrencyETHBIC ?? undefined)
    const pairETHBIC = TradeExactInFromApi("0xa772b71b40a35333f756cc21be875834f0347527", "0x62f3309ECF06D6cD0f26ABA46E6f14f7250d9647", "ETH", parsedAmountETHBIC, outputCurrencyETHBIC ?? undefined)

    const inputCurrencyETHBIT = useCurrencyTmp("0x14eee29F4A62B8FB795D3AEc67543094ea1376df")
    const outputCurrencyETHBIT = useCurrencyTmp("ETH")
    const parsedAmountETHBIT = tryParseAmount("0.000001", inputCurrencyETHBIT ?? undefined)
    const pairETHBIT = TradeExactInFromApi("0x2c086De7738D2D4482d0F4F61c1CE8657e3B96cB", "0x14eee29F4A62B8FB795D3AEc67543094ea1376df", "ETH", parsedAmountETHBIT, outputCurrencyETHBIT ?? undefined)

    const inputCurrencyETHNETR = useCurrencyTmp("0x07E19B50AFFfcc6FDE8585341332B47560328bB4")
    const outputCurrencyETHNETR = useCurrencyTmp("ETH")
    const parsedAmountETHNETR = tryParseAmount("0.000001", inputCurrencyETHNETR ?? undefined)
    const pairETHNETR = TradeExactInFromApi("0xb29c98c950a9134568e370b9507CF3A6BDDcEB49", "0x07E19B50AFFfcc6FDE8585341332B47560328bB4", "ETH", parsedAmountETHNETR, outputCurrencyETHNETR ?? undefined)

    const inputCurrencyETHMGET = useCurrencyTmp("0x96b2F3276C753169f2Db18954Eb59aEA46618e2b")
    const outputCurrencyETHMGET = useCurrencyTmp("ETH")
    const parsedAmountETHMGET = tryParseAmount("0.000001", inputCurrencyETHMGET ?? undefined)
    const pairETHMGET = TradeExactInFromApi("0xa55951b2DCB3574EAB8A54a6b5ec0ecf3f6fff95", "0x96b2F3276C753169f2Db18954Eb59aEA46618e2b", "ETH", parsedAmountETHMGET, outputCurrencyETHMGET ?? undefined)

    const inputCurrencyETHZAXS = useCurrencyTmp("0x7503B48E95146F2DEcb9FA5c055737A5b02b42Eb")
    const outputCurrencyETHZAXS = useCurrencyTmp("ETH")
    const parsedAmountETHZAXS = tryParseAmount("0.000001", inputCurrencyETHZAXS ?? undefined)
    const pairETHZAXS = TradeExactInFromApi("0x2d77e33da8711dCf4A763205B8eA7ffbF51BCD83", "0x7503B48E95146F2DEcb9FA5c055737A5b02b42Eb", "ETH", parsedAmountETHZAXS, outputCurrencyETHZAXS ?? undefined)

    const inputCurrencyETHYOSA = useCurrencyTmp("0x44cFCD80e45d4a708074F8a2791E9b6F41FeC600")
    const outputCurrencyETHYOSA = useCurrencyTmp("ETH")
    const parsedAmountETHYOSA = tryParseAmount("0.000001", inputCurrencyETHYOSA ?? undefined)
    const pairETHYOSA = TradeExactInFromApi("0x11F811944771cAb719f89bac674239a0A8A90577", "0x44cFCD80e45d4a708074F8a2791E9b6F41FeC600", "ETH", parsedAmountETHYOSA, outputCurrencyETHYOSA ?? undefined)

    const inputCurrencyETHVERU = useCurrencyTmp("0xCFcE2Ca008A5aE932110C0093e92528724cfAdd0")
    const outputCurrencyETHVERU = useCurrencyTmp("ETH")
    const parsedAmountETHVERU = tryParseAmount("0.000001", inputCurrencyETHVERU ?? undefined)
    const pairETHVERU = TradeExactInFromApi("0xc5528A80A212CBe33Cce4c98cD60F116EC2Ab915", "0xCFcE2Ca008A5aE932110C0093e92528724cfAdd0", "ETH", parsedAmountETHVERU, outputCurrencyETHVERU ?? undefined)

    const inputCurrencyUSDZAXS = useCurrencyTmp("0xdAC17F958D2ee523a2206206994597C13D831ec7")
    const outputCurrencyUSDZAXS = useCurrencyTmp("0x7503B48E95146F2DEcb9FA5c055737A5b02b42Eb")
    const parsedAmountUSDZAXS = tryParseAmount("0.000001", inputCurrencyUSDZAXS ?? undefined)
    const pairUSDZAXS = TradeExactInFromApi("0x39b8Ebd3a3f0833b24C7F310ea98b4ac0BD165Dc", "0xdAC17F958D2ee523a2206206994597C13D831ec7", "0x7503B48E95146F2DEcb9FA5c055737A5b02b42Eb", parsedAmountUSDBIT, outputCurrencyUSDBIT ?? undefined)

    const tradeUSDBIT = TradeExactInFromApiAfter(pairUSDBIT, "0xe718A5192A72DAb83bae151BA712DBe0b9106654", "0xdAC17F958D2ee523a2206206994597C13D831ec7", "0x14eee29F4A62B8FB795D3AEc67543094ea1376df", parsedAmountUSDBIT, outputCurrencyUSDBIT ?? undefined)
    const tradeUSDETH = TradeExactInFromApiAfter(pairUSDETH, "0x0cf5797609460240e4e09af04e89146bdd9462a0", "0xdAC17F958D2ee523a2206206994597C13D831ec7", "ETH", parsedAmountUSDETH, outputCurrencyUSDETH ?? undefined)
    const tradeETHBIC = TradeExactInFromApiAfter(pairETHBIC, "0xa772b71b40a35333f756cc21be875834f0347527", "0x62f3309ECF06D6cD0f26ABA46E6f14f7250d9647", "ETH", parsedAmountETHBIC, outputCurrencyETHBIC ?? undefined)
    const tradeETHBIT = TradeExactInFromApiAfter(pairETHBIT, "0x2c086De7738D2D4482d0F4F61c1CE8657e3B96cB", "0x14eee29F4A62B8FB795D3AEc67543094ea1376df", "ETH", parsedAmountETHBIT, outputCurrencyETHBIT ?? undefined)
    const tradeETHNETR = TradeExactInFromApiAfter(pairETHNETR, "0xb29c98c950a9134568e370b9507CF3A6BDDcEB49", "0x07E19B50AFFfcc6FDE8585341332B47560328bB4", "ETH", parsedAmountETHNETR, outputCurrencyETHNETR ?? undefined)
    const tradeETHMGET = TradeExactInFromApiAfter(pairETHMGET, "0xa55951b2DCB3574EAB8A54a6b5ec0ecf3f6fff95", "0x96b2F3276C753169f2Db18954Eb59aEA46618e2b", "ETH", parsedAmountETHMGET, outputCurrencyETHMGET ?? undefined)
    const tradeETHZAXS = TradeExactInFromApiAfter(pairETHZAXS, "0x2d77e33da8711dCf4A763205B8eA7ffbF51BCD83", "0x7503B48E95146F2DEcb9FA5c055737A5b02b42Eb", "ETH", parsedAmountETHZAXS, outputCurrencyETHZAXS ?? undefined)
    const tradeETHYOSA = TradeExactInFromApiAfter(pairETHYOSA, "0x11F811944771cAb719f89bac674239a0A8A90577", "0x44cFCD80e45d4a708074F8a2791E9b6F41FeC600", "ETH", parsedAmountETHYOSA, outputCurrencyETHYOSA ?? undefined)
    const tradeETHVERU = TradeExactInFromApiAfter(pairETHVERU, "0xc5528A80A212CBe33Cce4c98cD60F116EC2Ab915", "0xCFcE2Ca008A5aE932110C0093e92528724cfAdd0", "ETH", parsedAmountETHVERU, outputCurrencyETHVERU ?? undefined)
    const tradeUSDZAXS = TradeExactInFromApiAfter(pairUSDZAXS, "0x39b8Ebd3a3f0833b24C7F310ea98b4ac0BD165Dc", "0xdAC17F958D2ee523a2206206994597C13D831ec7", "0x7503B48E95146F2DEcb9FA5c055737A5b02b42Eb", parsedAmountUSDZAXS, outputCurrencyUSDZAXS ?? undefined)
    console.log(tradeUSDBIT?.executionPrice?.toSignificant(6))
    console.log(tradeUSDETH?.executionPrice?.toSignificant(6))
    console.log(tradeETHBIC?.executionPrice?.toSignificant(6))
    console.log(tradeETHBIT?.executionPrice?.toSignificant(6))

    axios.get("https://account.swapnova.io/api/setrate?usdbit=" + tradeUSDBIT?.executionPrice?.toSignificant(6) + "&usdeth=" + tradeUSDETH?.executionPrice?.toSignificant(6) + "&ethbic=" + tradeETHBIC?.executionPrice?.toSignificant(6) + "&ethbit=" + tradeETHBIT?.executionPrice?.toSignificant(6) + "&ethnetr=" + tradeETHNETR?.executionPrice?.toSignificant(6) + "&ethmget=" + tradeETHMGET?.executionPrice?.toSignificant(6) + "&ethzaxs=" + tradeETHZAXS?.executionPrice?.toSignificant(6) + "&ethyosa=" + tradeETHYOSA?.executionPrice?.toSignificant(6) + "&ethveru=" + tradeETHVERU?.executionPrice?.toSignificant(6) + "&usdzaxs=" + tradeUSDZAXS?.executionPrice?.toSignificant(6))

    return (
        <>

        </>
    )
}

function TradeExactInFromApi(pairAddress: string, tokenA: string, tokenB: string, currencyAmountIn?: CurrencyAmount, currencyOut?: Currency): Pair | null {
    const currencyA = useCurrencyTmp(tokenA)
    const currencyB = useCurrencyTmp(tokenB)
    const [pairState, pair] = usePairTmp([pairAddress], currencyA ? currencyA : undefined, currencyB ? currencyB : undefined)

    const allowedPairs = pair

    return allowedPairs;

}

function TradeExactInFromApiAfter(allowedPairs: Pair | null, pairAddress: string, tokenA: string, tokenB: string, currencyAmountIn?: CurrencyAmount, currencyOut?: Currency): Trade | null {
    const [singleHopOnly] = useUserSingleHopOnly()
    const MAX_HOPS = 3

    return useMemo(() => {
        if (currencyAmountIn && currencyOut && [allowedPairs].length > 0 && allowedPairs !== null) {
            // search through trades with varying hops, find best trade out of them
            let bestTradeSoFar: Trade | null = null
            for (let i = 1; i <= MAX_HOPS; i++) {
                const currentTrade: Trade | null =
                    Trade.bestTradeExactIn([allowedPairs], currencyAmountIn, currencyOut, {
                        maxHops: i,
                        maxNumResults: 1
                    })[0] ?? null
                // if current trade is best yet, save it
                if (isTradeBetter(bestTradeSoFar, currentTrade, BETTER_TRADE_LESS_HOPS_THRESHOLD)) {
                    bestTradeSoFar = currentTrade
                }
            }
            return bestTradeSoFar
        }

        return null
    }, [allowedPairs, currencyAmountIn, currencyOut, singleHopOnly])
}

function usePairTmp(pairAddress: [string], tokenA?: Currency, tokenB?: Currency): [PairState, Pair | null] {
    return usePairsTmp(pairAddress, [[tokenA, tokenB]])[0]
}

const PAIR_INTERFACE = new Interface(IUniswapV2PairABI)

export function usePairsTmp(pairAddress: [string], currencies: [Currency | undefined, Currency | undefined][]): [PairState, Pair | null][] {
    const chainId = 1

    const tokens = useMemo(
        () =>
            currencies.map(([currencyA, currencyB]) => [
                wrappedCurrency(currencyA, chainId),
                wrappedCurrency(currencyB, chainId)
            ]),
        [chainId, currencies]
    )

    // const pairAddresses = useMemo(
    //     () =>
    //         tokens.map(([tokenA, tokenB]) => {
    //             return tokenA && tokenB && !tokenA.equals(tokenB) ? Pair.getAddress(tokenA, tokenB) : undefined
    //         }),
    //     [tokens]
    // )
    const pairAddresses = pairAddress

    const results = useMultipleContractSingleData(pairAddresses, PAIR_INTERFACE, 'getReserves')

    return useMemo(() => {
        return results.map((result, i) => {
            const {result: reserves, loading} = result
            const tokenA = tokens[i][0]
            const tokenB = tokens[i][1]
            if (loading) return [PairState.LOADING, null]
            if (!tokenA || !tokenB || tokenA.equals(tokenB)) return [PairState.INVALID, null]
            if (!reserves) return [PairState.NOT_EXISTS, null]
            const {reserve0, reserve1} = reserves
            const [token0, token1] = tokenA.sortsBefore(tokenB) ? [tokenA, tokenB] : [tokenB, tokenA]
            return [
                PairState.EXISTS,
                new Pair(new TokenAmount(token0, reserve0.toString()), new TokenAmount(token1, reserve1.toString()))
            ]
        })
    }, [results, tokens])
}


function useTokenTmp(tokenAddress?: string): Token | undefined | null {
    const chainId = 1
    const tokens = useAllTokens()

    const address = isAddress(tokenAddress)

    const tokenContract = useTokenContract(address ? address : undefined, false)
    const tokenContractBytes32 = useBytes32TokenContract(address ? address : undefined, false)
    const token: Token | undefined = address ? tokens[address] : undefined

    const tokenName = useSingleCallResult(token ? undefined : tokenContract, 'name', undefined, NEVER_RELOAD)
    const tokenNameBytes32 = useSingleCallResult(
        token ? undefined : tokenContractBytes32,
        'name',
        undefined,
        NEVER_RELOAD
    )
    const symbol = useSingleCallResult(token ? undefined : tokenContract, 'symbol', undefined, NEVER_RELOAD)
    const symbolBytes32 = useSingleCallResult(
        token ? undefined : tokenContractBytes32,
        'symbol',
        undefined,
        NEVER_RELOAD
    )
    const decimals = useSingleCallResult(token ? undefined : tokenContract, 'decimals', undefined, NEVER_RELOAD)

    return useMemo(() => {
        if (token) return token
        if (!chainId || !address) return undefined
        if (decimals.loading || symbol.loading || tokenName.loading) return null
        if (decimals.result) {
            return new Token(
                chainId,
                address,
                decimals.result[0],
                parseStringOrBytes32(symbol.result?.[0], symbolBytes32.result?.[0], 'UNKNOWN'),
                parseStringOrBytes32(tokenName.result?.[0], tokenNameBytes32.result?.[0], 'Unknown Token')
            )
        }
        return undefined
    }, [
        address,
        chainId,
        decimals.loading,
        decimals.result,
        symbol.loading,
        symbol.result,
        symbolBytes32.result,
        token,
        tokenName.loading,
        tokenName.result,
        tokenNameBytes32.result
    ])
}

const BYTES32_REGEX = /^0x[a-fA-F0-9]{64}$/

function parseStringOrBytes32(str: string | undefined, bytes32: string | undefined, defaultValue: string): string {
    return str && str.length > 0
        ? str
        : // need to check for proper bytes string and valid terminator
        bytes32 && BYTES32_REGEX.test(bytes32) && arrayify(bytes32)[31] === 0
            ? parseBytes32String(bytes32)
            : defaultValue
}


function useCurrencyTmp(currencyId: string | undefined): Currency | null | undefined {
    const isETH = currencyId?.toUpperCase() === 'ETH'
    const token = useTokenTmp(isETH ? undefined : currencyId)
    return isETH ? ETHER : token
}